const LOCAL_HOSTNAMES = new Set(["localhost", "127.0.0.1", "[::1]"]);

const isLocalHostname = (hostname) => LOCAL_HOSTNAMES.has(hostname);

const getDefaultAdminHostname = () => {
    if (typeof window !== "undefined" && isLocalHostname(window.location.hostname)) {
        return "admin.localhost";
    }

    return "admin.meetsnworks.com";
};

export const getAdminHostname = () =>
    process.env.REACT_APP_ADMIN_HOSTNAME?.trim() || getDefaultAdminHostname();

export const getAdminHostnames = () => {
    const configuredHostnames = process.env.REACT_APP_ADMIN_HOSTNAMES || getAdminHostname();

    return configuredHostnames
        .split(",")
        .map((hostname) => hostname.trim().toLowerCase())
        .filter(Boolean);
};

export const isAdminHost = () => {
    if (typeof window === "undefined") {
        return false;
    }

    return getAdminHostnames().includes(window.location.hostname.toLowerCase());
};

export const getAdminUrl = (path = "/") => {
    const normalizedPath = path.startsWith("/") ? path : `/${path}`;
    const adminHostname = getAdminHostname();
    const currentHostname = typeof window !== "undefined" ? window.location.hostname : "";
    const useLocalProtocol = isLocalHostname(currentHostname) || isLocalHostname(adminHostname);
    const protocol = useLocalProtocol ? "http:" : "https:";
    const port = useLocalProtocol && typeof window !== "undefined" && window.location.port
        ? `:${window.location.port}`
        : "";

    return `${protocol}//${adminHostname}${port}${normalizedPath}`;
};
